import {inject, Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {User} from '../../interfaces/listUserResponse';
import {ApiUtilService} from './api-util.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  apiUtilService = inject(ApiUtilService);
  currentUser!: User;

  private listRefreshSubject = new Subject<void>();

  get listRefresh$(): Observable<void> {
    return this.listRefreshSubject.asObservable();
  }

  triggerListRefresh() {
    this.listRefreshSubject.next();
  }

  constructor() {
  }

  /**
   * 編集者ユーザーを追加
   * @param projectName
   * @param userName
   * @param email
   */
  async addMaintainerUser(projectName: string, userName: string, email: string): Promise<Observable<any>> {
    const body = {
      projectName,
      userName,
      mail: email,
    }
    return await this.apiUtilService.sendPostRequest('cms/addMaintainer', body);
  }

  /**
   * 同じプロジェクトのユーザーリストを取得する
   * @param projectName
   */
  async listProjectUser(projectName: string = ''): Promise<Observable<any>> {
    return await this.apiUtilService.sendPostRequest('cms/getUserList', {projectName});
  }

  /**
   * 編集者ユーザーを削除する
   * @param projectName
   * @param userName
   * @param email
   */
  async deleteMaintainerUser(projectName: string, userName: string, email: string): Promise<Observable<any>> {
    const body = {
      projectName,
      userName,
      mail: email,
    }
    return await this.apiUtilService.sendPostRequest('cms/deleteMaintainer', body);
  }

  async updateUserDescription(projectName: string, userName: string, description: string): Promise<Observable<Object>> {
    const body = {
      projectName,
      userName,
      description,
    }
    return await this.apiUtilService.sendPostRequest('cms/updateUserDescription', body);
  }
}
